module.exports = " <taxonomy-fieldtype name=categories :config=fieldConfig :data.sync=formData.fields[config.name] :leave-alert=true></taxonomy-fieldtype> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/publish/MetaFields/Taxonomy.vue
// module id = 308
// module chunks = 0